<script lang="ts">
    import { SortedCreatures } from "./store";
    import Creature from "./Creature.svelte";
</script>

<div>
    <div class="creatures">
        {#each $SortedCreatures as creature}
            <Creature {creature} />
        {/each}
    </div>
</div>

<style>
    .creatures {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: center;
    }
</style>
